<template>
    <div
        v-if="isFaqLoadedWithError"
        class="inline-warning-block"
    >
        {{ $t('errors.faqOpening') }}
    </div>
    <FeedbackForm />
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import FeedbackForm from '@components/FeedbackForm';
import api from '@/api';
import testNetwork from '@/modules/networkStatus';

export default {
    name: 'TheFeedback',
    components: {
        FeedbackForm,
    },
    computed: {
        ...mapState({
            queryParams: state => state.queryParams,
            isNetworkTestLoaded: state => state.feedback.networkTest.isLoaded,
            isFaqLoadedWithError: state => state.FAQ.isFaqLoadedWithError,
        }),
    },
    created() {
        if (!this.isNetworkTestLoaded) this.requestNetworkTest();
    },
    mounted() {
        window.addEventListener('beforeunload', this.beforeUnloadEvent);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.beforeUnloadEvent);
    },
    methods: {
        ...mapMutations({
            setNetworkTestData: 'feedback/setNetworkTestData',
            setNetworkTestLoaded: 'feedback/setNetworkTestLoaded',
        }),
        requestNetworkTest() {
            api.getGameServers(this.queryParams)
                .then(response => ({
                    servers: response.data.data,
                    pushdStatus: this.queryParams?.pushd ?? '-'
                }))
                .then(testNetwork)
                .then(result => {
                    this.setNetworkTestData(result);
                    this.setNetworkTestLoaded();
                })
                .catch(err => {
                    console.error(err);
                });
        },
        beforeUnloadEvent(event) {
            event.preventDefault()
            event.returnValue = '';
        },
    }

}
</script>